<mat-form-field
  [appearance]="fillClass ? fillClass : null"
  [class]="class ? class : 'mb-3'">
  <mat-label>{{ label }}</mat-label>
  <input
    class="m-0"
    type="text"
    matInput
    [value]="value ? value : ''"
    [placeholder]="label"
    [disabled]="isDisabled"
    [attr.maxlength]="maxlength"
    #input />
  <mat-icon matPrefix>search</mat-icon>
  <mat-hint> {{ helperText }}</mat-hint>
</mat-form-field>
